import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { ACTION_DOTS_HORIZONTAL_ICON } from '../../constants/assetConstants';
import { ACTION_DOTS_HORIZONTAL3_ICON } from '../../constants/assetConstants';
import './DropdownMenuItem.scss';
import cx from 'classnames';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}>
    {children}
    <img src={ACTION_DOTS_HORIZONTAL3_ICON} width={24} height={24} alt="more" />
  </a>
));

export const DropdownMenuItem = ({ items, data, parentClass }) => {
  return (
    <div>
      <Dropdown>
        <Dropdown.Toggle as={CustomToggle} />
        <Dropdown.Menu size="sm" title="" className={cx(!parentClass ? "dropdownRoot" : "dropDownRootParent")} >
          {items?.map((item, index) => {
            return (
              <Dropdown.Item
                className="menuItem"
                key={index}
                onClick={() => item.onMouseDown(data)}>
                {item.label}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
